/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchDTOCompany
 */
export interface SearchDTOCompany {
    /**
     * 
     * @type {string}
     * @memberof SearchDTOCompany
     */
    name: string;
}

/**
 * Check if a given object implements the SearchDTOCompany interface.
 */
export function instanceOfSearchDTOCompany(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function SearchDTOCompanyFromJSON(json: any): SearchDTOCompany {
    return SearchDTOCompanyFromJSONTyped(json, false);
}

export function SearchDTOCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchDTOCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function SearchDTOCompanyToJSON(value?: SearchDTOCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

